<template>
    <div>
        <div class="reItemns" v-if="list.length > 0">
            <div class="reItemm flx alc jsb" v-for="item,index in list" @click="toDetail(item)">
                <div class="reLeft">
                    <div class="rlt flx alc">
                        <div class="rname" v-html="setRedText(item.name,keyword)"></div>
                        <div class="rsalary" v-text="`${item.salary_mix} ~ ${item.salary_max}`"></div>
                    </div>
                    <div class="rlv flx alc">
                        <div class="rlabel" v-text="item.exp_name"></div>
                        <div class="rlabel" v-text="item.eb_name"></div>
                    </div>
                    <div class="rlb flx alc">
                        <i class="el-icon-location" style="color: #555C70;"></i>
                        <span v-text="item.city_name"></span>
                        <span> · </span>
                        <span v-text="item.area_name"></span>
                    </div>
                </div>
                <div class="remiddle">
                    <div class="comTop flx alc">
                        <img :src="$img(item.shop_avatar)" alt="">
                        <div v-text="item.shop_name"></div>
                    </div>
                    <div class="rlv flx alc">
                        <div class="rlabel" v-text="`${item.shop_people}人`"></div>
                        <div class="rlabel" v-text="item.shop_label"></div>
                    </div>
                </div>
            </div>
        </div>
        <div v-else style="box-sizing: border-box;padding-top: 100rpx;">
            <img :src="$Localimg('nosearch.png')" class="nodatas" alt="">
        </div>
    </div>
</template>
<script>
    export default {
        name: "jobsearch",
        props: {
            list: Array,
            keyword: String
        },
        data() {
            return {};
        },
        created() {
            let that = this
        },
        methods: {
            toDetail(e){
                this.$router.push({
                    path: '/RecruitmentDetail', // 写路由path
                    query: {
                        id: e.id,
                    }
                })
            },
            setRedText(text, key) {
                if (!key) return text;
                // 正则g全局匹配，忽略大小写加i
                const reg = new RegExp(key, "g");
                // 替换为红色span标签
                return text.replace(reg, `<span style="color:red">${key}</span>`);
            }
        }
    };
</script>

<style scoped>
    .reRight {
        width: 88px;
        height: 36px;
        background: #007AFF;
        border-radius: 3px;
        text-align: center;
        line-height: 36px;
        font-size: 14px;
        color: #FFFFFF;
        cursor: pointer;
    }

    .comTop img {
        width: 22px;
        height: 22px;
        margin-right: 8px;
    }

    .comTop div {
        font-size: 16px;
        color: #222222;
    }

    .rlb {
        font-size: 14px;
        color: #555C70;
    }

    .rlabel {
        height: 23px;
        background: #F5F7FA;
        border-radius: 2px;
        font-size: 12px;
        color: #555C70;
        line-height: 23px;
        padding: 0 9px;
        margin: 12px 0;
        margin-right: 10px;
    }

    .rsalary {
        font-weight: 500;
        font-size: 18px;
        color: #007AFF;
    }

    .rname {
        font-weight: 600;
        font-size: 18px;
        color: #000000;
        margin-right: 14px;
    }

    .reLeft {
        width: 440px;

    }

    .reItemm {
        margin: 0 auto;
        background: #fff;
        border-radius: 10px;
        width: 100%;
        box-sizing: border-box;
        padding: 20px;
        margin-top: 16px;
        width: 90%;
        border-radius: 10px 10px 10px 10px;
        border: 1px solid #D9D9D9;
    }

    .reItemns {
        width: 100%;
    }
</style>